module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.openPop) ? _c('Popup', {
    on: {
      "close": function($event) {
        _vm.openPop = false
      }
    }
  }, [_c('div', {
    staticClass: "p-3",
    attrs: {
      "slot": "table"
    },
    slot: "table"
  }, [(_vm.recognizeData) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "55vh"
    },
    attrs: {
      "id": "style-1"
    }
  }, [_c('table', {
    staticClass: "table table-borderless"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('learning_contents')))]), _vm._v(" "), _c('th', [_vm._v("失敗次數")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('play')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('download')))])])]), _vm._v(" "), _vm._l((_vm.recognizeData.data), function(item, index) {
    return _c('tbody', {
      key: index,
      staticStyle: {
        "border-top": "1px #cccccc solid",
        "text-align": "left"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v("\n                " + _vm._s(item.sentence) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.recognizeTimes) + "\n              ")]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "pointer",
      staticStyle: {
        "color": "blue"
      },
      on: {
        "click": function($event) {
          return _vm.playAudio(item.voiceUrl)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('play')) + "\n                ")])]), _vm._v(" "), _c('td', [_c('a', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "download": "",
        "target": "_blank",
        "href": item.voiceUrl
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('download')) + "\n                ")])])])])
  })], 2), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "audio"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.voiceUrl,
      "type": "audio/ogg"
    }
  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "px-5",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(this.userInfo.realName))]), _vm._v(" "), _c('label-tag'), _vm._v(" "), _c('div', {
    staticClass: "px-5 table-responsive",
    staticStyle: {
      "overflow": "auto",
      "min-height": "50vh",
      "font-size": "1.25rem"
    }
  }, [_c('table', {
    staticClass: "table table-borderless table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            任務主題\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("任務點")]), _vm._v(" "), _c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            任務關卡\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            挑戰時間\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            任務評價\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            完成時間\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n            " + _vm._s(_vm.$t('oral_practice')) + "\n          ")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "text-align": "left"
    }
  }, _vm._l((_vm.record.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n            " + _vm._s(item.missionName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.missionPointName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.sceneName ? item.sceneName : '-') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.createTime) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.grade ? item.grade : '-') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.spendTime) + "\n          ")]), _vm._v(" "), _c('td', [(!item.hasRecognize) ? _c('a', {
      staticClass: "disabled",
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_vm._v("\n              detal\n            ")]) : _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.goInfo(item.recordId)
        }
      }
    }, [_vm._v("\n              detal\n            ")])])])
  }), 0)])]), _vm._v(" "), _c('Pagination', {
    staticClass: "mt-5",
    attrs: {
      "current": _vm.record.pageIndex,
      "total": _vm.record.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72ed3942!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/tw/record/RecordMissionInfo.vue
// module id = 798
// module chunks = 3